import React, {useEffect, useRef} from "react";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import {useNavigate} from "react-router";

const AuthEmailResponse: React.FC = () => {
    const navigate = useNavigate();
    const processingRef = useRef(false);

    useEffect(() => {
        if (processingRef.current) {
            return;
        }

        const auth = getAuth();
        const signInUrl = window.location.href;

        if (isSignInWithEmailLink(auth, signInUrl)) {
            processingRef.current = true;
            let email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                email = window.prompt('Please provide your email for confirmation') || '';
            }

            if (!email) {
                navigate('/login');
                return;
            }

            const emailToSignInWith = email;

            signInWithEmailLink(auth, emailToSignInWith, signInUrl)
                .then(() => {
                    window.localStorage.removeItem('emailForSignIn');
                    navigate('/home');
                })
                .catch((error) => {
                    console.error('Sign-in error:', error);
                    if (error.code === 'auth/invalid-action-code' && auth.currentUser) {
                        window.localStorage.removeItem('emailForSignIn');
                        navigate('/home');
                        return;
                    }
                    alert('Failed to sign in: ' + error.message);
                    navigate('/login');
                });
        } else {
            navigate('/');
        }
    }, [navigate]);

    return (
        <>
            <div className={'loading'}>
                Loading...
            </div>
        </>
    );
};

export default AuthEmailResponse;
